import { FillPaint } from "mapbox-gl";
import { ATTENTION_RED, ATTENTION_RED_LINE, CADMIUM_ORANGE, STAGE_YELLOW, STAGE_YELLOW_LINE } from "@src/styles/colors";

export const SELECTED_SECTION_FILL_PAINT: FillPaint = {
	"fill-color": ATTENTION_RED,
	"fill-opacity": 0.6,
	"fill-outline-color": ATTENTION_RED_LINE,
};

export const USERS_SECTION_FILL_PAINT: FillPaint = {
	"fill-color": STAGE_YELLOW,
	"fill-opacity": 0.6,
	"fill-outline-color": STAGE_YELLOW_LINE,
};

export const COMPARATIVE_SECTION_FILL_PAINT: FillPaint = {
	"fill-color": CADMIUM_ORANGE,
	"fill-opacity": 0.4,
};
